RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PostTypeFilter = Marionette.ItemView.mixin({
        template: '#postTypeFilterTemplate',
        tagName: 'span',

        ui: {
            highlight: '.highlight-color'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            DropdownSelector: {}
        },

        defaultSelector: function () {
            const me = this;

            const filter = me.getProp('filter');

            if (filter) {
                return `[data-type="${filter}"]`;
            } else {
                return ':first';
            }
        },

        onSelectDropdown: function (data) {
            const me = this;

            me.setProps('filter', data.type);

            me.ui.highlight.toggleClass('highlighted', Boolean(data.type));

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedInsightsPostType, {
                channel: me.getProp('channel'),
                type: data.type
            });
        },

        templateHelpers: function () {
            const me = this;

            const channel = me.getProp('channel');
            const postTypes = (channel === RivalIQ.enums.channels.FACEBOOK ? RivalIQ.apps.Insights.data.facebookInsightsPostTypes() : RivalIQ.apps.Insights.data.linkedInInsightsPostTypes());
            return {
                postTypes: postTypes,
                highlighted: Boolean(me.getProp('filter'))
            };
        }
    });
});
